import { render } from "./EditLoginImage.vue?vue&type=template&id=c0a9f68c"
import script from "./EditLoginImage.vue?vue&type=script&lang=js"
export * from "./EditLoginImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__